import { render } from "./DocuSign.vue?vue&type=template&id=1b15ac82"
import script from "./DocuSign.vue?vue&type=script&lang=js"
export * from "./DocuSign.vue?vue&type=script&lang=js"
script.render = render

export default script